import { API } from "@/lib/api";

export function productImage(p, w) {
  if (!p) return null;
  if (p.image_url) return p.image_url;
  if (p.image_path) return `${API}/media/${p.image_path}${w ? `?w=${w}` : ""}`;
  return null;
}

export function formatPrice(v) {
  return new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(v || 0);
}

export function productTitle(p, lang) {
  return lang === "en" ? (p.title_en || p.title_it) : (p.title_it || p.title_en);
}

export function productDesc(p, lang) {
  return lang === "en" ? (p.description_en || p.description_it) : (p.description_it || p.description_en);
}

export function productShortDesc(p, lang) {
  if (!p) return "";
  return (lang === "en" ? (p.short_description_en || p.short_description_it) : (p.short_description_it || p.short_description_en)) || "";
}

export function categoryName(c, lang) {
  return lang === "en" ? (c.name_en || c.name_it) : (c.name_it || c.name_en);
}
